import { getRequestHeaders, handleRes } from "utils";
import { PhoneType, Violation } from "types";

export const getColorList = (): Promise<string[]> => {
  return fetch(`${window.VEHICLE_BASE_URL}/vehicle/colors`, {
    method: "GET",
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<string[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

export const getPhoneTypes = (): Promise<PhoneType[]> => {
  return fetch(`${window.USER_BASE_URL}/lists/phoneTypes`, {
    method: "GET",
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<PhoneType[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

export const getStandardViolations = (): Promise<Violation[]> => {
  return fetch(`${window.PROPERTY_BASE_URL}/lists/violations`, {
    method: "GET",
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<Violation[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};
